import * as TypeGraphQL from "type-graphql";
export var InstitutionalSentimentMetricsScalarFieldEnum;
(function (InstitutionalSentimentMetricsScalarFieldEnum) {
    InstitutionalSentimentMetricsScalarFieldEnum["id"] = "id";
    InstitutionalSentimentMetricsScalarFieldEnum["timestamp"] = "timestamp";
    InstitutionalSentimentMetricsScalarFieldEnum["operation"] = "operation";
    InstitutionalSentimentMetricsScalarFieldEnum["totalRecords"] = "totalRecords";
    InstitutionalSentimentMetricsScalarFieldEnum["successCount"] = "successCount";
    InstitutionalSentimentMetricsScalarFieldEnum["errorCount"] = "errorCount";
    InstitutionalSentimentMetricsScalarFieldEnum["processingTimeMs"] = "processingTimeMs";
    InstitutionalSentimentMetricsScalarFieldEnum["batchSize"] = "batchSize";
    InstitutionalSentimentMetricsScalarFieldEnum["createdAt"] = "createdAt";
})(InstitutionalSentimentMetricsScalarFieldEnum || (InstitutionalSentimentMetricsScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(InstitutionalSentimentMetricsScalarFieldEnum, {
    name: "InstitutionalSentimentMetricsScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=InstitutionalSentimentMetricsScalarFieldEnum.js.map